import "./index.scss"
import React from "react"
import { Link } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

export default function StrategicImperativesGraphic({ component }) {
  const { circleLinks, background } = component
  const bg = background[0]

  //Mapping over links and filtering by color - as all the circles are slightly different so we
  //can't make an array that maps automatically
  const greyLink = circleLinks.filter(link => link.color === "grey")
  const greenLink = circleLinks.filter(link => link.color === "teal")
  const purpleLink = circleLinks.filter(link => link.color === "purple")
  const magentaLink = circleLinks.filter(link => link.color === "magenta")
  
  return (
    <div className="si-graphic-section">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-12">
            <div className="desktop-icon">
              <Link className="circle teal" href={greenLink[0].link}>
                {greenLink[0].name}
              </Link>
              <Link className="circle purple" to={purpleLink[0].link}>
                {purpleLink[0].name}
              </Link>
              <Link className="circle grey" to={greyLink[0].link}>
                {greyLink[0].name}
              </Link>
              <Link className="circle magenta" to={magentaLink[0].link}>
                {magentaLink[0].name}
              </Link>
            </div>
            <div className="graphic-wrapper mobile">
              <svg
                width="630"
                height="630"
                viewBox="0 0 630 630"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  opacity="0.95"
                  cx="157.5"
                  cy="314.5"
                  r="157.5"
                  fill="#6E7491"
                />
                {/* <foreignObject x="50" y="250" r="157.5" width="200" height="150">
                    <div xmlns="http://www.w3.org/1999/xhtml">{greyLink[0].name}</div>
                </foreignObject> */}
                <circle
                  opacity="0.95"
                  cx="315.5"
                  cy="157.5"
                  r="157.5"
                  transform="rotate(-90 315.5 157.5)"
                  fill="#18988B"
                />
                {/* <text x="315.5" y="157.5" fill="#fff" text-anchor="middle">{greenLink[0].name}</text> */}
                <g id="magenta">
                  <circle
                    opacity="0.95"
                    cx="315.5"
                    cy="472.5"
                    r="157.5"
                    transform="rotate(-90 315.5 472.5)"
                    fill="#FD495C"
                  />
                </g>
                <g id="purple">
                  <circle
                    opacity="0.95"
                    cx="472.5"
                    cy="314.5"
                    r="157.5"
                    fill="#655DC6"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_1158_17692">
                    <rect width="630" height="630" fill="white" />
                  </clipPath>
                </defs>
              </svg>
              {circleLinks.map(link => (
                <div key={link.link} className={`link-div ${link.color}`}>
                  <Link to={link.link}>{link.name}</Link>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
      {bg.hasBackgroundImage && (
        <GatsbyImage image={getImage(bg.image)} className="bg-image" alt="" />
      )}
    </div>
  )
}
